/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsFolderArrowDownLeft: {
  name: 'folder-arrow-down-left';
  data: string;
} = {
  name: 'folder-arrow-down-left',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M4 3a2 2 0 0 0-2 2v5a1 1 0 1 0 2 0V5h4.586L11 7.414A2 2 0 0 0 12.414 8H20v10h-8a1 1 0 1 0 0 2h8a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.586L10 3.586A2 2 0 0 0 8.586 3H4Zm0 11a1 1 0 1 0-2 0v5a1 1 0 0 0 1 1h5a1 1 0 1 0 0-2H5.414l3.293-3.293a1 1 0 1 0-1.414-1.414L4 16.586V14Z" fill="currentColor"/></svg>`,
};
